import { BaseDto } from './base.dto'
import { FileDto } from './file.dto'
import { TranslationDto } from './translation.dto'

export class FloorMapManagementDto extends BaseDto {
  public mallId?: string
  public mallName?: TranslationDto
  public floorName?: string
  public floorCode?: string
  public geojson?: Record<string, unknown>
  public staticMap?: FileDto | null
  public baseMap?: FileDto | null

  public static create(data?: Partial<FloorMapManagementDto>): FloorMapManagementDto {
    const instance = new FloorMapManagementDto()
    if (data) {
      Object.assign(instance, data)
    }
    return instance
  }
}

export class FloorMapInteractiveFloorOptionDto {
  public id: string
  public floorName: string
}

export class FloorMapInteractiveModeDto {
  public floorMapInteractiveMode: boolean
}
